import React from 'react';
import {
    DialogContent,
    Dialog,
    DialogActions,
    DialogTitle,
    Button,
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert';

const RewardLogDialog = ({ _message, _severity, _isLoading, _handleClose }) => {

    return (
        <Dialog
            fullWidth={true}
            maxWidth='md'
            open={true}
        >
            <DialogTitle disableTypography={true} style={{ fontSize: '20px' }}>
                Claim Challenge Reward
            </DialogTitle>

            {
                _isLoading ?
                    <Alert style={{ margin: "10px" }} variant="outlined" severity="info">
                        Please wait for a while...
                    </Alert>
                    :
                    <>
                        <DialogContent>
                            <Alert style={{ margin: "10px" }} variant="outlined" severity={_severity}>
                                {_message}
                            </Alert>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={_handleClose}>
                                Ok
                            </Button>
                        </DialogActions>
                    </>
            }
        </Dialog>
    );
};

export default RewardLogDialog;
